<template>
  <div class="sale__counter sale-counter" v-if="stream">
    <div class="sale-counter__body">

      <div
        class="sale-counter__sale"
        v-if="stream.status == 'prepare'">{{ stream.date_start | moment("D MMMM") }}</div>

      <div
        class="sale-counter__sale"
        v-if="stream.status == 'process'">Уже завтра!</div>

      <div class="sale-counter__title">Старт потока</div>
      <div class="sale-counter__text">Похудение под контролем нутрициолога и четырехкратного чемпиона мира по пауэрлифтингу всего <strong>за 166 рубль</strong> в день!</div>
    </div>
    <div class="sale-counter__counter">
      <div class="sale-counter__counter-title">До старта</div>
      <div class="sale-counter__counter-block">
          <div id="countdown" class="countdown"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import jQuery from 'jquery'

import {settings} from '../variables.js'


export default {

  name: 'StreamCountdown',

  data () {
    return {
      staticBase: settings.staticBase,
      stream: null
    }
  },

  mounted () {
    axios.get("/lk/api/actual-stream/").then(response => {
      this.stream = response.data

      var dateCountdown = new Date()

      if (this.stream.status == 'prepare') {
        dateCountdown = this.stream.date_start
      }
      else if (this.stream.status == 'process') {
        dateCountdown = new Date(
          dateCountdown.getFullYear(),
          dateCountdown.getMonth(),
          dateCountdown.getDate(), 0, 0, 0).getTime() + 86400000*1
      }

      jQuery(document).ready(function () {
        jQuery('#countdown').countdown(dateCountdown, function(event) {
          jQuery(this).html(event.strftime(
            '<span class="countdown__item">%-D дней</span> <span class="countdown__item">%-H часов</span> <span class="countdown__item">%M мин</span> <span class="countdown__item">%S сек</span>'
          ));
        })
      })

    });
  }
}
</script>

<style lang="css" scoped>
</style>